// src/components/Hero.jsx
import React from "react";
import "./Hero.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faAt } from '@fortawesome/free-solid-svg-icons';


const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div
        className="hero-image"
        style={{
          backgroundImage: 'url("avatar.jpg")',
        }}
      ></div>
      <div  className="hero-content">
        <h1>Ganesh Amgain</h1>
        <h2>Psychotherapist, Mental Health Counselor, Lecturer, Researcher & Yoga Instructor</h2>
        <h2><FontAwesomeIcon icon={faPhone} style={{color: "#26a69a", fontSize: "20px"}} /> +977 <a href="tel:9849081162">984-9081162</a>,  <a href="tel:9801172544">980-1172544</a></h2>
        <h2><FontAwesomeIcon icon={faAt} style={{color: "#26a69a", fontSize: "20px"}} />  <a href="mailto:ganeshamgain@gmail.com">ganeshamgain@gmail.com</a></h2>
        <a href="#contact">
          <button className="hero-button">Book a Session</button>
        </a>
      </div>
    </section>
  );
};

export default Hero;
